var _metadata, _defs, _rect, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 157.23 48",
    width: 157.23,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("meta", {
    name: "Producer",
    content: "Online-Convert"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, "\n      .st0 {\n        fill: #d3ac68;\n      }\n\n      .st1 {\n        fill: none;\n      }\n\n      .st2 {\n        fill: #154b85;\n      }\n\n      .st3 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 1.39,
    y: 1,
    width: 157.23,
    height: 48,
    id: "rect4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 1.39,
    y: 1,
    width: 157.23,
    height: 48,
    id: "rect7"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 0,
    y: 0,
    width: 157.23,
    height: 48,
    id: "rect12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st4",
    clipPath: "url(#clippath)",
    id: "g20",
    transform: "translate(-1.39,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 131.81,39.06 c 0.54,-0.68 0.82,-1.65 0.82,-2.91 0,-1.26 -0.27,-2.2 -0.82,-2.86 -0.55,-0.66 -1.33,-1 -2.34,-1 -1.01,0 -1.8,0.33 -2.34,1 -0.55,0.67 -0.82,1.62 -0.82,2.86 0,1.24 0.27,2.23 0.82,2.91 0.54,0.68 1.32,1.02 2.34,1.02 1.02,0 1.8,-0.34 2.34,-1.02 m -4.87,1.15 c -0.71,-0.36 -1.25,-0.89 -1.62,-1.58 -0.37,-0.69 -0.56,-1.52 -0.56,-2.48 0,-0.96 0.19,-1.76 0.56,-2.44 0.38,-0.68 0.92,-1.2 1.62,-1.56 0.71,-0.36 1.55,-0.53 2.53,-0.53 0.98,0 1.82,0.18 2.53,0.53 0.71,0.36 1.25,0.87 1.62,1.56 0.38,0.68 0.56,1.5 0.56,2.44 0,0.94 -0.19,1.79 -0.56,2.48 -0.37,0.69 -0.92,1.22 -1.62,1.58 -0.71,0.36 -1.55,0.55 -2.53,0.55 -0.98,0 -1.82,-0.18 -2.53,-0.55",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 140.4,36.31 h 2.12 c 0.72,0 1.27,-0.15 1.66,-0.45 0.39,-0.3 0.59,-0.8 0.59,-1.51 0,-0.71 -0.19,-1.19 -0.59,-1.49 -0.39,-0.3 -0.94,-0.45 -1.66,-0.45 h -2.12 z m 5.74,3.65 c 0.15,0.31 0.31,0.49 0.45,0.55 v 0.13 h -1.56 c -0.26,-0.31 -0.52,-0.83 -0.78,-1.57 -0.22,-0.61 -0.44,-1.08 -0.65,-1.42 -0.22,-0.34 -0.49,-0.56 -0.83,-0.66 h -2.37 v 3.66 h -1.54 v -8.89 h 3.65 c 2.52,0 3.79,0.87 3.79,2.62 0,1.29 -0.7,2.11 -2.11,2.45 0.31,0.16 0.57,0.39 0.79,0.69 0.22,0.3 0.43,0.71 0.63,1.23 0.2,0.52 0.38,0.93 0.54,1.23",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 151.68,40 c -0.73,-0.51 -1.13,-1.23 -1.2,-2.16 h 1.28 c 0.06,0.78 0.32,1.35 0.79,1.71 0.47,0.36 1.17,0.54 2.09,0.54 0.8,0 1.4,-0.14 1.81,-0.43 0.41,-0.29 0.62,-0.71 0.62,-1.26 0,-0.32 -0.08,-0.59 -0.23,-0.81 -0.15,-0.22 -0.43,-0.42 -0.82,-0.59 -0.39,-0.17 -0.95,-0.34 -1.67,-0.49 -1.14,-0.24 -2.03,-0.55 -2.68,-0.93 -0.65,-0.38 -0.97,-0.93 -0.97,-1.65 0,-0.8 0.36,-1.38 1.07,-1.75 0.71,-0.37 1.63,-0.56 2.77,-0.56 1.14,0 2.11,0.21 2.75,0.64 0.65,0.43 1.02,1.02 1.11,1.77 h -1.27 c -0.12,-0.62 -0.4,-1.06 -0.84,-1.33 -0.44,-0.27 -1.05,-0.41 -1.83,-0.41 -0.72,0 -1.27,0.13 -1.65,0.38 -0.37,0.25 -0.56,0.59 -0.56,1.02 0,0.25 0.07,0.47 0.21,0.65 0.14,0.18 0.39,0.35 0.77,0.5 0.37,0.15 0.91,0.3 1.6,0.46 0.89,0.19 1.6,0.4 2.14,0.62 0.54,0.22 0.95,0.51 1.23,0.88 0.28,0.36 0.43,0.83 0.43,1.41 0,0.8 -0.35,1.43 -1.06,1.88 -0.71,0.45 -1.67,0.67 -2.88,0.67 -1.21,0 -2.26,-0.25 -2.99,-0.76",
    id: "path18"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3",
    clipPath: "url(#clippath-1)",
    id: "g26",
    transform: "translate(-1.39,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 83.49,16.76 h 14.02 l 0.44,-0.35 V 13.63 L 97.51,13.28 H 83.49 V 9.23 h 17.13 c 0.26,0 0.53,0.08 0.82,0.25 0.29,0.16 0.55,0.37 0.79,0.62 0.24,0.25 0.44,0.53 0.6,0.83 0.16,0.3 0.24,0.58 0.24,0.85 v 5.79 c 0,0.62 -0.13,1.15 -0.4,1.59 -0.27,0.44 -0.62,0.81 -1.06,1.08 -0.44,0.28 -0.93,0.48 -1.47,0.61 -0.55,0.13 -1.1,0.19 -1.65,0.19 l 6.73,6.25 h -7.01 l -6.76,-6.25 h -2.98 v 6.25 h -4.98 z",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 110.5,12.48 v 11.57 c 0,0.58 0.11,1.07 0.32,1.47 0.21,0.41 0.5,0.74 0.86,1 0.36,0.26 0.76,0.45 1.21,0.58 0.44,0.12 0.91,0.19 1.39,0.19 h 12.68 c 0.44,0 0.89,-0.07 1.33,-0.2 0.45,-0.14 0.85,-0.34 1.21,-0.62 0.36,-0.28 0.66,-0.62 0.89,-1.03 0.23,-0.41 0.35,-0.87 0.35,-1.39 v -3.01 h -4.92 v 2.08 H 115.39 V 13.4 h 10.43 v 2.11 h 4.92 v -3.04 c 0,-0.52 -0.12,-0.98 -0.35,-1.39 -0.23,-0.41 -0.53,-0.75 -0.89,-1.03 -0.36,-0.28 -0.76,-0.49 -1.21,-0.62 -0.45,-0.13 -0.89,-0.2 -1.33,-0.2 h -12.68 c -0.48,0 -0.95,0.06 -1.39,0.19 -0.45,0.13 -0.85,0.32 -1.21,0.58 -0.36,0.26 -0.65,0.59 -0.86,1 -0.21,0.4 -0.32,0.9 -0.32,1.47",
    id: "path24"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g58",
    transform: "translate(-1.39,-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 47.53,25 C 47.53,38.25 37.2,49 24.46,49 11.72,49 1.39,38.25 1.39,25 1.39,11.75 11.72,1 24.46,1 37.2,1 47.53,11.75 47.53,25",
    id: "path28"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M 24.45,3.97 15.57,19.96 6.69,35.95 h 6.89 c -0.43,-1.24 -0.67,-2.6 -0.67,-3.99 0,-3.73 1.63,-7.06 4.2,-9.26 1.99,-1.73 4.56,-2.75 7.34,-2.75 2.78,0 5.35,1.02 7.34,2.75 2.57,2.2 4.2,5.53 4.2,9.26 0,1.39 -0.23,2.75 -0.67,3.99 h 6.89 z",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 24.45,41.96 c -3.94,0 -7.33,-2.47 -8.81,-6 h -2.06 c 1.57,4.67 5.84,8.01 10.87,8.01 5.03,0 9.3,-3.35 10.87,-8.01 h -2.04 c -1.48,3.54 -4.87,6 -8.83,6 z",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 18.09,24.5 6.37,11.46 6.37,-11.48 c -1.7,-1.58 -3.92,-2.52 -6.37,-2.52 -2.45,0 -4.67,0.94 -6.37,2.54 z",
    id: "path34"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "62.51,39.96 56.59,39.96 56.59,36.2 61.83,36.2 61.83,35.54 56.59,35.54 56.59,32.42 62.51,32.42 62.51,31.74 55.05,31.74 55.05,40.63 62.51,40.63 ",
    id: "polygon40"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "66.81,40.63 73.69,40.63 73.69,39.96 68.35,39.96 68.35,31.74 66.81,31.74 ",
    id: "polygon42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "85.38,39.96 79.46,39.96 79.46,36.2 84.7,36.2 84.7,35.54 79.46,35.54 79.46,32.42 85.38,32.42 85.38,31.74 77.92,31.74 77.92,40.63 85.38,40.63 ",
    id: "polygon44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "89.21,31.74 93.48,40.76 94.37,40.76 98.74,31.74 97.74,31.74 94.2,39.01 90.89,31.74 ",
    id: "polygon46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 105.39,31.62 -4.45,9.02 h 1.05 l 1.08,-2.29 h 4.74 l 1.03,2.29 h 1.62 l -4.19,-9.02 h -0.89 z m -1.98,6.05 2.11,-4.45 1.99,4.45 z",
    id: "path48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "116.19,40.63 117.73,40.63 117.73,32.42 121.31,32.42 121.31,31.74 112.6,31.74 112.6,32.42 116.19,32.42 ",
    id: "polygon50"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "59.5,27.29 60.3,25.82 63.59,19.36 65.84,14.77 67.99,18.72 67.99,18.73 69.04,20.67 68.97,20.67 71.44,25.59 72.35,27.29 77.55,27.29 68.4,9.24 63.48,9.24 54.25,27.29 ",
    id: "polygon52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "142.3,16.24 142.3,9.24 137.35,9.24 137.35,27.29 142.3,27.29 142.3,20.41 152.7,20.41 152.7,27.29 157.66,27.29 157.66,9.24 152.7,9.24 152.7,16.24 ",
    id: "polygon54"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4eb6f37d9824c27dcf37eaa903623521.svg";
export { ForwardRef as ReactComponent };